import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CountoStubDirective } from './counto-stub.directive';
import { GooglePlaceDirective } from './google-place.directive';
import { Nvd3StubComponent } from './nvd3-stub.component';
import {
    PerfectScrollbarStubComponent,
    PerfectScrollbarStubDirective
} from './perfect-scrollbar-stub.directive';
import { TextMaskStubDirective } from './text-mask-stub.directive';
import { ImageCropperModule } from './image-cropper-compat.module';
import { GridsterModule } from './gridster-compat.module';

/**
 * Drop-in compatibility module that ships local Ivy-compatible replacements for
 * directives and components from third-party packages that became unmaintained
 * during the Angular 15 -> 17 upgrade. Importing the package-named sub-modules
 * below from `@shared/compat` keeps existing imports/templates intact while
 * removing the dependency on the abandoned npm packages.
 *
 * Each directive/component is declared in exactly one NgModule (the package-named
 * one) and re-exported from `CompatModule` via `exports`, so consumers can either
 * import the named modules individually or pull in the umbrella module.
 */

@NgModule({
    imports: [CommonModule],
    declarations: [PerfectScrollbarStubDirective, PerfectScrollbarStubComponent],
    exports: [PerfectScrollbarStubDirective, PerfectScrollbarStubComponent]
})
export class PerfectScrollbarModule {}

@NgModule({
    imports: [CommonModule],
    declarations: [CountoStubDirective],
    exports: [CountoStubDirective]
})
export class CountoModule {}

@NgModule({
    imports: [CommonModule],
    declarations: [TextMaskStubDirective],
    exports: [TextMaskStubDirective]
})
export class TextMaskModule {}

@NgModule({
    imports: [CommonModule],
    declarations: [Nvd3StubComponent],
    exports: [Nvd3StubComponent]
})
export class NvD3Module {}

@NgModule({
    imports: [CommonModule],
    declarations: [GooglePlaceDirective],
    exports: [GooglePlaceDirective]
})
export class GooglePlaceModule {}

@NgModule({
    imports: [
        CommonModule,
        PerfectScrollbarModule,
        CountoModule,
        TextMaskModule,
        NvD3Module,
        GooglePlaceModule,
        ImageCropperModule,
        GridsterModule
    ],
    exports: [
        PerfectScrollbarModule,
        CountoModule,
        TextMaskModule,
        NvD3Module,
        GooglePlaceModule,
        ImageCropperModule,
        GridsterModule
    ]
})
export class CompatModule {}

export {
    PerfectScrollbarStubDirective,
    PerfectScrollbarStubComponent,
    PERFECT_SCROLLBAR_CONFIG,
    PerfectScrollbarConfigInterface
} from './perfect-scrollbar-stub.directive';
export { CountoStubDirective } from './counto-stub.directive';
export { TextMaskStubDirective } from './text-mask-stub.directive';
export { Nvd3StubComponent } from './nvd3-stub.component';
export { GooglePlaceDirective } from './google-place.directive';
export { ImageCropperModule } from './image-cropper-compat.module';
export { GridsterModule } from './gridster-compat.module';
